module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', [_c('header', {
    staticClass: "view__header"
  }, [_c('h2', {
    staticClass: "view__title"
  }, [_vm._v(_vm._s(_vm.L.localize('Settings_Breadcrumb_Billing')))])]), _vm._v(" "), _c('article', {
    staticClass: "view__content"
  }, [_c('div', {
    staticClass: "view__panel"
  }, [_c('div', {
    staticClass: "form js-form"
  }, [_c('submenu'), _vm._v(" "), _c('div', {
    staticClass: "options-list"
  }, [_c('div', {
    staticClass: "options-list__item"
  }, [_c('div', {
    staticClass: "options-list__content"
  }, [_c('h2', {
    staticClass: "options-list__title"
  }, [_vm._v("Stripe")]), _vm._v(" "), _c('h6', {
    staticClass: "options-list__subtitle"
  }, [_vm._v(_vm._s(_vm.L.localize('Label_Stripe_Description')))])]), _vm._v(" "), _c('div', {
    staticClass: "options-list__control"
  }, [(_vm.tenant.stripe.connected) ? _c('a', {
    staticClass: "button button--border",
    attrs: {
      "href": "javascript: void(0)",
      "data-acc": "toggle"
    },
    on: {
      "click": _vm.unlink
    }
  }, [_vm._v("\n                " + _vm._s(_vm.L.localize('Label_Unlink')) + "\n              ")]) : _c('a', {
    staticClass: "button button--border",
    attrs: {
      "href": _vm.tenant.stripe.endpoint,
      "data-acc": "toggle"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.L.localize('Settings_Breadcrumb_Billing_Button')) + "\n              ")])])])])], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1c283302!./~/vue-loader/lib/selector.js?type=template&index=0!./scripts/components/views/membership/PaymentGateways.vue
// module id = 716
// module chunks = 1